export default __webpack_public_path__ + "static/media/search.7bc6ed7f.svg";